import { Component, OnInit, ViewChildren, QueryList, HostListener, ElementRef } from '@angular/core';
import { SortEvent, NgbdSortableHeader } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { TemplateModel } from '../../business-entities/template-model';
import { TemplateBusinessService } from '../../business-services/template-service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TemplateListRequestModel } from '../../business-entities/template-advance-search-value.model';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { TemplateType } from '../../../../../Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { ModuleModel } from '../../business-entities/module-model';
import { UserTypeModel } from '../../business-entities/user-type-model';
import { TemplateUsageModel } from '../../business-entities/template-usage-model';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { DashboardService } from '../../business-services/dashboard.service';
import { AutomaticUpdatesService } from '../../business-services/automatic-updates.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-automatic-updates',
  templateUrl: './automatic-updates.component.html',
  styleUrls: ['./automatic-updates.component.css']
})
export class AutomaticUpdatesComponent implements OnInit {

  //#region Declaration

  isShowAdvanced: boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  isDealerLoggedIn: boolean;
  currentlagSub: Subscription;
  selectedLanguage: any;

  channelType = TemplateType;
  templateList: TemplateModel[] = [];
  dealerList: Array<SelectListItemViewModel>;
  actionTypeList: any[];
  templateTypeList: SelectListItemViewModel[];
  templateUsageList: TemplateUsageModel[];
  userTypeList: UserTypeModel[];
  moduleList: ModuleModel[];
  statusList: StatusViewModel[] = [];

  requestModel: TemplateListRequestModel = {
    searchTerm: '',
    startRecordNumber: 0,
    numberOfRecord: 25,
    sortColumn: '',
    sortDirection: 'desc',
    currentLanguage: '',
    dealerId: '',
    name: '',
    subject: '',
    actionCode: null,
    templateType: null,
    templateUsageId: null,
    applicationId: null,
    userTypeId: null,
    statusId: null
  };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  totalCount: any;
  throttle = 100;
  scrollDistance = 1;
  searchTerm = '';
  activeSelectAll: boolean = false;

  //#endregion

  //#region Constructor & OnInit

  constructor(
    private templateService: TemplateBusinessService,
    public dealerBusinessService: DealerBusinessService,
    public automaticUpdatesService: AutomaticUpdatesService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private secureStorage: SecureStorage,
    private userService: UserDataService,
    private dashboardService: DashboardService,
    private currentLanguageService: CurrentLanguage,
    config: NgbModalConfig,
    private _eref: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.requestModel.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[])
      .find(menu => menu.moduleId === fromEnums.ModuleNames.AutomaticUpdates);

    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.requestModel.currentLanguage = x;
      if (this.selectedLanguage != x) {
        this.selectedLanguage = x;
        this.GetTemplateList();  
      }
      else{
        this.selectedLanguage = x;
      }
    });
    this.GetDropDownLists();
  }

  //#endregion

  //#region Page Methods

  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option') == -1 && event.target.className.indexOf('btn') == -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isShowAdvanced = false;
      }
    }
  }

  mapDealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.templateList.length) {
      this.requestModel.startRecordNumber = this.templateList.length
      this.GetTemplateList(false);
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModel.sortColumn = column;
    this.requestModel.sortDirection = direction;
    this.requestModel.startRecordNumber = 0;
    this.spinner.show();
    this.GetTemplateList();
  }

  onReset() {
    this.requestModel = {
      searchTerm: '',
      startRecordNumber: 0,
      numberOfRecord: 25,
      sortColumn: '',
      sortDirection: 'desc',
      currentLanguage: this.selectedLanguage,
      dealerId: '',
      name: '',
      subject: '',
      actionCode: null,
      templateType: null,
      templateUsageId: null,
      applicationId: null,
      userTypeId: null,
      statusId: null
    }
    this.GetTemplateList();
  }

  onAdvSearch() {
    this.isShowAdvanced = !this.isShowAdvanced;
  }

  onAdvSearchCancel() {
    this.isShowAdvanced = false;
  }

  AdvanceSearchSubmit() {
    this.isShowAdvanced = false;
    this.GetTemplateList();
  }

  onDealerSelected(dealerId: string, isRefreshList) {
    this.requestModel.dealerId = dealerId;
    if (isRefreshList) {
      this.isShowAdvanced = false;
      this.GetTemplateList();
    }
    else {
      this.isShowAdvanced = true;
    }
  }

  onQuickSearch() {
    this.GetTemplateList();
  }

  onActiveAllChange(){
    this.activeSelectAll = !this.activeSelectAll;
    this.templateList.forEach(template => {
      template.isActiveUpdate = this.activeSelectAll
    });
  }

  //#endregion

  //#region API Methods

  async GetDropDownLists() {
    this.spinner.show();
    await this.templateService.GetTemplate(0).then(res => {
      const data = res.responseObject;
      this.templateTypeList = data.templateTypeList;
      this.actionTypeList = data.actionTypeList;
      this.moduleList = data.moduleList;
      this.userTypeList = data.userTypeList;
      this.templateUsageList = data.templateUsageList;
    }).finally(() => {
      this.spinner.hide();
    });

    this.GetUserDealers();
    this.statusList = this.dashboardService.getStatusList();
  }

  async GetUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapDealer(response.userDealersModel);
      this.templateService.dealerList = this.dealerList;
      if (this.dealerList.length === 1) {
        this.requestModel.dealerId = this.dealerList[0].value;
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  async GetTemplateList(isReset: boolean = true) {
    this.spinner.show();
    await this.automaticUpdatesService.GetList(this.requestModel).then(res => {
      if (isReset) {
        this.templateList = [];
        this.totalCount = 0;
      }
      if (res.responseObject.length > 0) {
        this.templateList.push(...res.responseObject);
        this.totalCount = res.responseObject[0].totalCount;
        if (isReset) {
          this.activeSelectAll = this.templateList.filter(x=>x.isActive)?.length > 0;
        }
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }

  onSaveChanges() {
    let successMsg = this.translate.instant("lblTemplatesUpdatedMsg");
    let errorMsg = this.translate.instant("lblTemplatesNotUpdatedMsg");
    if (this.templateList?.length > 0) {
      let templates = [];
      this.templateList.forEach(val => {
        if (val.isActive != val.isActiveUpdate) {
          templates.push({
            templateCode: val.templateCode,
            isActive: val.isActiveUpdate
          }); 
        }
      });
      this.spinner.show();
      this.automaticUpdatesService.Update(templates).then((res) => {
        if (res.responseObject === true) {
          this.toastr.success(successMsg);
          this.onQuickSearch();
        }
        else {
          this.toastr.error(errorMsg);
        }
      }).finally(() => {
        this.spinner.hide();
      })
    }
    else {
      this.toastr.error(errorMsg);
    }
  }
  //#endregion
}
